import { render } from "./APList.vue?vue&type=template&id=1da5548d&scoped=true&lang=pug"
import script from "./APList.vue?vue&type=script&lang=ts"
export * from "./APList.vue?vue&type=script&lang=ts"

import "./APList.vue?vue&type=style&index=0&id=1da5548d&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-1da5548d"

export default script